import React from 'react';
import { Stack, Button } from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const PaymentOptions = ({
  paymentMode,
  setPaymentMode,
  wallet,
  direct_pay,
}) => {
  return (
    <React.Fragment>
      <Stack gap=".5em">
        <Button
          variant="contained"
          fullWidth
          sx={{
            color:
              paymentMode === 0
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              paymentMode === 0
                ? `${themeColors.ColorPrimary} !important`
                : '',
          }}
          onClick={() => {
            // handleSaveNearestTurn(
            //   doctorList,
            //   navigate,
            //   confirmMsg
            //   // priceTag
            // );
            setPaymentMode(0);
          }}
        >
          {wallet}
        </Button>
        <Button
          variant="contained"
          fullWidth
          sx={{
            color:
              paymentMode === 1
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              paymentMode === 1
                ? `${themeColors.ColorPrimary} !important`
                : '',
          }}
          onClick={() => {
            // handleSaveNearestTurn(
            //   doctorList,
            //   navigate,
            //   confirmMsg,
            //   priceTag
            // );
            setPaymentMode(1);
          }}
        >
          {direct_pay}
        </Button>
      </Stack>
    </React.Fragment>
  );
};

export default PaymentOptions;
